module.exports = __webpack_public_path__ + "img/sasha.0b5eb84.png";